"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) {
    if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = void 0;

__exportStar(require("./validators"), exports);

var transfer_1 = require("./transfer");

var mass_transfer_1 = require("./mass-transfer");

var alias_1 = require("./alias");

var burn_1 = require("./burn");

var cancel_lease_1 = require("./cancel-lease");

var data_1 = require("./data");

var sponsorship_1 = require("./sponsorship");

var set_asset_script_1 = require("./set-asset-script");

var set_script_1 = require("./set-script");

var reissue_1 = require("./reissue");

var issue_1 = require("./issue");

var lease_1 = require("./lease");

var invoke_script_1 = require("./invoke-script");

var exchange_1 = require("./exchange");

var update_asset_info_1 = require("./update-asset-info");

var order_1 = require("./order");

var cancel_order_1 = require("./cancel-order");

var custom_data_1 = require("./custom-data");

var auth_1 = require("./auth");

var wavesAuth_1 = require("./wavesAuth");

exports.validate = {
  transfer: transfer_1.transferValidator,
  massTransfer: mass_transfer_1.massTransferValidator,
  alias: alias_1.aliasValidator,
  issue: issue_1.issueValidator,
  reissue: reissue_1.reissueValidator,
  sponsorship: sponsorship_1.sponsorshipValidator,
  burn: burn_1.burnValidator,
  setAssetScript: set_asset_script_1.setAssetScriptValidator,
  cancelLease: cancel_lease_1.cancelLeaseValidator,
  data: data_1.dataValidator,
  lease: lease_1.leaseValidator,
  setScript: set_script_1.setScriptValidator,
  invokeScript: invoke_script_1.invokeValidator,
  exchange: exchange_1.exchangeValidator,
  updateAssetInfo: update_asset_info_1.updateAssetInfoValidator,
  cancelOrder: cancel_order_1.cancelOrderValidator,
  customData: custom_data_1.customDataValidator,
  order: order_1.orderValidator,
  wavesAuth: wavesAuth_1.authValidator,
  auth: auth_1.authValidator
};